(function() { window.GUID_77d55924_c1ca_45d1_a10b_def3916ec97f = { getGuid: function() { return "77d55924-c1ca-45d1-a10b-def3916ec97f"; } }; })();
var CS;
(function (CS) {
    var Enumeration;
    (function (Enumeration) {
        let PictureSize;
        (function (PictureSize) {
            PictureSize[PictureSize["Small"] = 0] = "Small";
            PictureSize[PictureSize["Medium"] = 1] = "Medium";
            PictureSize[PictureSize["Large"] = 2] = "Large";
            PictureSize[PictureSize["Thumb"] = 3] = "Thumb";
        })(PictureSize = Enumeration.PictureSize || (Enumeration.PictureSize = {}));
    })(Enumeration = CS.Enumeration || (CS.Enumeration = {}));
})(CS || (CS = {}));

//# sourceMappingURL=PictureSize.pre.js.map
